var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "lamp-notif-sized-container-for-mobile": this.isMobile,
        "lamp-notif-sized-container-for-desktop-with-notifs":
          !this.isMobile && _vm.notifications.length > 0
      },
      style: { height: this.isMobile ? "100vh" : "unset" }
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex flex-column lamp-notif-container",
          class: { "lamp-notif-container-mobile": this.isMobile }
        },
        [
          _vm.notifications.length > 0
            ? _vm._l(_vm.notifications, function(notification, index) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "intersect",
                        rawName: "v-intersect",
                        value: function() {
                          return _vm.markAsViewed(notification)
                        },
                        expression: "() => markAsViewed(notification)"
                      }
                    ],
                    key: index,
                    staticClass: "lamp-notif d-flex",
                    on: {
                      click: function($event) {
                        return _vm.updateNotifAndRedirect(notification, $event)
                      }
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "lamp-notif-icon-part d-flex justify-content-center"
                      },
                      [
                        _c("i", {
                          staticClass: "ph-custom align-self-center",
                          class: [_vm.getIconForNotificationType(notification)]
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "lamp-notif-texts-part" }, [
                      _c("div", { staticClass: "lamp-notif-timeText" }, [
                        _vm._v(
                          _vm._s(
                            _vm.convertTimestampToRelativeDate(
                              notification.date
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("p", { staticClass: "lamp-notif-content" }, [
                        _c("span", { staticClass: "lamp-notif-title" }, [
                          _vm._v(_vm._s(notification.title))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "lamp-notif-description" }, [
                          _vm._v(_vm._s(notification.body))
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "lamp-notif-new-part d-flex justify-content-end"
                      },
                      [
                        _c("transition", { attrs: { name: "fade" } }, [
                          !notification.updateViewed
                            ? _c("div", { staticClass: "lamp-notif-new" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("new.notif")) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ])
                      ],
                      1
                    )
                  ]
                )
              })
            : [
                _c("div", { staticClass: "lamp-no-notif" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("Notifs.none")) + "\n      "
                  )
                ])
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bfc62f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bfc62f7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/menus/NotifsMenu.vue
// module id = EOnx
// module chunks = 0